<template>
  <li class="icon-message-item" :class="[{ 'is-original-image': isOriginalImageSize }]">
    <div ref="contentContainer" class="icon-message-content">
      <component
        :is="iconMessageWidget"
        ref="icon"
        v-bind="iconMessageProps"
        @closeIconMessage="$emit('close', message)"
        @image-loaded="$emit('image-loaded')"
      >
        <template v-slot:close>
          <i class="close" @click.prevent.stop="$emit('close', message)"></i>
        </template>
      </component>
    </div>
  </li>
</template>

<script>
import Action from './IconMessages/Action.vue'
import IconImage from './IconMessages/IconImage.vue'
import Plain from './IconMessages/Plain.vue'

export default {
  components: {
    Action,
    IconImage,
    Plain
  },

  props: {
    index: { type: Number, required: true },
    message: { type: Object, required: true },
    toggleChat: { type: Function, required: true },
    clone: Boolean
  },

  computed: {
    iconMessageProps() {
      return {
        index: this.index,
        message: this.message,
        openChat: this.openChat
      }
    },

    isOriginalImageSize() {
      return this.message.type === 'icon_image' && this.message.image_size === 'original'
    },

    iconMessageWidget() {
      switch (this.message.type) {
        case 'icon_action':
          return 'Action'
        case 'icon_image':
          return 'IconImage'
        default:
          return 'Plain'
      }
    }
  },

  created() {
    this.popIconMessage()
  },

  mounted() {
    if (!this.clone) {
      this.$gtag.recordIconMessageDisplayed(this.message)
    }
  },

  methods: {
    openChat() {
      this.toggleChat()
      this.$gtag.recordEventChatOpen('Icon message', this.message.id)
    },

    popIconMessage() {
      const hideDelay = this.message.hideDelay
      if (hideDelay > 0) {
        setTimeout(() => {
          this.$emit('auto-hide', this.message)
        }, hideDelay * 1000)
      }
    }
  }
}
</script>
